import { render, staticRenderFns } from "./index.vue?vue&type=template&id=50608d7b&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=50608d7b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../_workspace/production-sync-20260815/repo/vue/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50608d7b",
  null
  
)

export default component.exports